import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col } from 'react-flexbox-grid'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import * as routes from 'services/routes/selectors'
import * as routeActions from 'services/routes/actions'
import * as user from 'services/user/selectors'
import styles from './_recentRoutes.css'
import RouteThumb from 'components/home/shared/RouteThumb'

const mapStateToProps = (state) => ({
  userId: user.selectUserId(state),
  userRoutes: routes.selectUserRoutes(state),
  noRoutes: routes.selectNoUserRoutesFound(state),
})

const mapDispatchToActions = {
  ...routeActions,
}

export class RecentRoutes extends Component {
  static propTypes = {
    userId: PropTypes.number,
    getRoutesByUser: PropTypes.func,
    userRoutes: PropTypes.array,
    noRoutes: PropTypes.bool,
  }

  componentWillMount () {
    const { userId, getRoutesByUser } = this.props
    getRoutesByUser(userId, 4)
  }

  render () {
    const { userRoutes, noRoutes } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h3 className={styles.headerText}>
            <FormattedMessage id='home.dashboard.recentroutes' defaultMessage='Recent Routes' />
          </h3>
          <Link className={styles.viewAll} to='/routes/my_routes/'>
            <FormattedMessage id='home.dashboard.recentroutes.view' defaultMessage='View All' />
          </Link>
        </div>
        {noRoutes ?
          <FormattedMessage id='home.dashboard.recentroutes.404' defaultMessage='No routes found.' />
        : null}
        <Row>
          {userRoutes.map((route, i) => {
            return (
              <Col key={i} xs={3}>
                <RouteThumb route={route} />
              </Col>
            )
          })}
        </Row>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(RecentRoutes)
